module.exports = __webpack_public_path__ + "static/media/vietnamese-noodle-bar.92ed8894.jpg";